import React from "react";
import { Link } from "react-router-dom";
import images from "../utils/imageLoader";
import Seo from "../components/Seo";
import data from "../data/projects_db.json";
import "../style/style-pages/projects-page.css";

const projects = data.projects.filter((project) => project.image);

const Projects = () => {
    return (
        <main className="projects-page">
            <Seo
                canonicalPath="/projectpage"
                description="Explore WiseCursor products and customer experiences across agentic AI, UX strategy, digital operations, financial planning, and service design."
                title="Projects"
            />
            <section className="projects-page__hero">
                <div className="container">
                    <span className="projects-page__eyebrow">Our Projects</span>
                    <h1>Products and experiences built around real operational needs.</h1>
                    <p>
                        Explore active WiseCursor products, agentic experiments, and customer-facing experiences. Each project clearly identifies its current maturity and available evidence.
                    </p>
                </div>
            </section>

            <section className="projects-page__grid-section">
                <div className="container">
                    <div className="projects-page__grid">
                        {projects.map((project) => (
                            <article className="projects-page__card" key={project.id}>
                                <img src={images[project.image]} alt="" />
                                <div className="projects-page__card-copy">
                                    <div className="projects-page__meta">
                                        <span>{project.category}</span>
                                        <span>{project.status}</span>
                                    </div>
                                    <h2>{project.name}</h2>
                                    <p>{project.desc}</p>
                                    <Link aria-label={`View ${project.name} project`} to={`/projects/${project.id}`}>View project</Link>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Projects;
